module.exports = __webpack_public_path__ + "img/2.3a76e3c9.png";